import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import _ from 'lodash';

import ErrorHandler from '@/support/ErrorHandler';

import { User } from '@/models/User';

import { Options } from '@/components/mi-dialog/MiDialog';
import LoaderCard from '@/components/loader-card/LoaderCard';
import {Rpc} from "@/models/Rpc";

@Component<QRDialog>({
  components: {
    LoaderCard,
  },
})
export default class QRDialog extends Vue {
  @Prop({default: null})
  protected user!: User;

  protected qrImage: string = '';
  protected token1: string = '';
  protected token2: string = '';
  protected mfaKey: string = '';

  protected isLoading: boolean = false;

  protected mounted() {
    this.initialize();
  }

  protected initialize() {
    this.fetchQRCode();
  }

  protected fetchQRCode() {
    this.isLoading = true;

    new Rpc()
      .execute('mfa:generate', {
        "name": "Maison365"
      })
      .then((response: any) => {
        this.qrImage = response.image as string;
        this.mfaKey = response.secret;
        this.isLoading = false;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected create() {
    if (!this.token1 || !this.token2 || !this.mfaKey) {
      return;
    }

    new Rpc()
      .execute('mfa:update', {
        "secret": this.mfaKey,
        "token": this.token1,
        "token_verify": this.token2
      })
      .then(() => {
        this.$store.dispatch('openDialog', this.dialogOptions);
        this.$emit('input', false);
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected close() {
    this.$emit('input', false);
  }

  protected get dialogOptions(): Options {
    return {
      title: `Success`,
      text: 'MFA succesvol aangemaakt',
      type: 'success',
      buttons: {
        confirm: {
          text: 'Ok',
        },
      },
    };
  }
}
